import { ElMessage } from 'element-plus';
import errorIcon from '@/assets/svgs/error.svg';
import copySuccessIcon from '@/assets/imgs/register/green_success.png';

const linkifyLine = (line: string) => {
    const urlMatch = line.match(/(https?:\/\/\S+)/);
    if (!urlMatch || urlMatch.index === undefined) return line;

    const url = urlMatch[0];
    const before = line.slice(0, urlMatch.index);
    const after = line.slice(urlMatch.index + url.length);

    return (
        <>
            {before}
            <a href={url} target="_blank" rel="noopener noreferrer">
                {url}
            </a>
            {after}
        </>
    );
};

const renderCopyContentMessage = (title: string, content: string) => (
    <div class="message-copy-content">
        <div class="message-copy-content__title">
            <img src={copySuccessIcon} width="16" height="16" alt="" />
            <span>{title}</span>
        </div>
        <div class="message-copy-content__body">
            {content.split('\n').map((line, index) => (
                <div key={index} class="message-copy-content__line">
                    {linkifyLine(line)}
                </div>
            ))}
        </div>
    </div>
);

export const Message = {
    success: (message: string, duration = 2000) =>
        ElMessage.success({
            message,
            customClass: 'message__success',
            duration,
        }),

    copyContent: (title: string, content: string, duration = 3000) =>
        ElMessage.success({
            message: renderCopyContentMessage(title, content),
            customClass: 'message__copy-content',
            duration,
            showClose: false,
            icon: () => <span />,
        }),

    warning: (message: string, duration = 3000) =>
        ElMessage.warning({
            message,
            customClass: 'message__warning',
            duration,
        }),

    error: (message: string, duration = 5000, isShowIcon = true) =>
        ElMessage.error({
            customClass: 'message__error',
            message,
            duration,
            icon: () => <img src={errorIcon} width="24px" height="24px" />,
        }),
};
